export interface MpfTagProps {
  text: string;
  colour: string;
}

export const mpfTagDefaults = {
  colour: 'blue',
} satisfies Partial<MpfTagProps>;
